<template>
  <div class="time-att-report">
      <div class="content-section">
        <table>
            <thead class="page-head">
                <tr colspan="3">
                    <th class="report-logo">
                        <div>
                            <img :src="companyLogo">
                        </div>
                    </th>
                    <th class="text-header">
                        <div class="text-left">
                            <div>รายงานแสดงข้อมูลเข้าออกผู้เยี่ยมเยือน</div>
                            <div>ระบบลงเวลา OLAF</div>
                        </div>
                    </th>
                    <th class="text-header">
                        <div class="text-end">
                            <div>{{ reportTimeText }}</div>
                            <div>{{ reportPeriodText }}</div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="page-content">
                <tr>
                    <td colspan="3">
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:15%;">ชื่อ - นามสกุล</th>
                                    <th style="width:13%;">เบอร์โทรศัพท์</th>
                                    <th style="width:20%;">เข้าเยี่ยมสำนักงาน / หน่วยงาน</th>
                                    <th style="width:12%;">ชื่อบุคคลที่มาเข้าพบ</th>
                                    <th style="width:10%;">วันที่</th>
                                    <th style="width:10%;">เวลา</th>
                                    <th style="width:10%;">สถานที่</th>
                                    <th style="width:10%;">อุณหภูมิ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="dataList.length === 0">
                                    <td colspan="12" style="width:100%; text-align: center;">ไม่พบข้อมูลการลงเวลา</td>
                                </tr>
                                <tr
                                    v-else
                                    v-for="(data, index) in dataList"
                                    :key="index">
                                    <td style="text-align: left;">{{ data.visitor_fullname }}</td>
                                    <td style="text-align: center;">{{ data.visitor_phone }}</td>
                                    <td style="text-align: left;">{{ data.visitor_bureau }}</td>
                                    <td style="text-align: center;">{{ data.visitor_employeeName }}</td>
                                    <td style="text-align: center;">{{ data.date }}</td>
                                    <td style="text-align: center;">{{ data.time }}</td>
                                    <td style="text-align: left;">{{ data.device_name }}</td>
                                    <td style="text-align: center;">{{ data.temperature }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
            <tfoot class="page-footer">
                <tr>
                    <td colspan="3">
                        <div class="flex-footer">
                            <div>หมายเหตุ : สถานที่ หมายถึง อุปกรณ์สแกนใบหน้า</div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
      </div>
  </div>
</template>

<script>
export default {
    name: 'ReportVisitorActivityPDF',

    data () {
        return {
            companyLogo: null,
            reportTimeText: null,
            reportPeriodText: null,
            dataList: []
        }
    },

    methods: {
        async genPdfReport (formData) {
            await this.$store.dispatch('setLoading', true)
            const form = {
                search: formData.search,
                dateRange: formData.dateRange,
                location: formData.location
            }

            const res = await this.axios.post('visitor/punch-log/export/pdf', form)
            if (res && res.data && res.data.status === 'ok') {
                this.companyLogo = res.data.data.companyLogo
                this.reportTimeText = res.data.data.reportTimeText
                this.reportPeriodText = res.data.data.reportPeriodText
                this.dataList = res.data.data.dataList
                return true
            } else {
                return false
            }
        }
    },

    async mounted () {
        const formData = localStorage.getItem('formData')
        localStorage.removeItem('formData')
        await this.genPdfReport(JSON.parse(formData)) // get data list
        await this.$store.dispatch('setLoading', false)

        // print pdf
        window.onafterprint = () => {
            setTimeout(window.close, 600)
        }
        setTimeout(window.print, 600)
    }

}
</script>

<style lang="scss" scoped>
.time-att-report {
    margin: 0mm 12mm;
    font-family: "Sarabun", sans-serif;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    text-align: left;
    color: #37323c;
    display: table;
}

@page {
    size: A4 landscape;
    margin: 2cm;
}

@media print {
    body {
        -webkit-print-color-adjust: exact;
    }
    .page-header th {
        height: 10mm;
    }
    .flex-footer {
        position: fixed;
        bottom: 10mm;
    }
}

.page-footer {
    display: table-footer-group;
    background-color: white;
    td {
        height: 20mm;
    }
}

.page-content {
    table {
        width: 100%;
        border-collapse: collapse;
        th, td {
            border: 1px solid;
        }
        td {
            padding: 0.1cm
        }
        th {
            text-align: center;
            background-color: rgb(200, 200, 200) !important;
        }
    }
}
table {
    width: 100%;
}
.text-center {
    text-align: center;
}

.text-header {
    padding: 1rem;
    .text-left{
        text-align: left;
    }
    .text-end{
        text-align: end;
    }
}

.report-logo {
    width: 1em;
    height: 3cm;
    img {
        height: 2cm;
    }
}
</style>
